import React from 'react';
import styles from './index.css';
import CommentBox from '../commentBox';
class HotList extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            replyId: '',
        };
        this.setReplyId = (replyId) => {
            this.setState({
                replyId,
            });
        };
    }
    render() {
        const { replyId } = this.state;
        const { tag, content: { comments }, limitHeight, showEmptyCommentTip, allow_comment, curPage, } = this.props;
        let title = '';
        if (tag === 'recent' && comments.length > 0) {
            title = '最新评论';
        }
        if (tag === 'recent' && comments.length === 0 && showEmptyCommentTip) {
            title = '最新评论';
        }
        if (!tag && comments.length > 0) {
            title = '最热评论';
        }
        return (React.createElement("div", null,
            React.createElement("div", { className: styles.title }, title),
            React.createElement("div", { className: styles.hotList, style: comments.length > 0 && limitHeight !== '' ? { height: limitHeight, overflow: 'auto' } : {} }, comments.map((item, index) => (React.createElement(CommentBox, { key: index, content: item, replyId: replyId, setReplyId: this.setReplyId, allow_comment: allow_comment, curPage: curPage })))),
            comments.length === 0 && showEmptyCommentTip ? (React.createElement("div", { className: styles.emptyComment }, "\u6682\u65E0\u8BC4\u8BBA\uFF0C\u6B22\u8FCE\u53D1\u8868\u60A8\u7684\u89C2\u70B9")) : null));
    }
}
export default HotList;
